var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teacher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M22.9751 16.0498V22.2123C22.9751 23.7998 21.7376 25.4998 20.2501 25.9998L16.2626 27.3248C15.5626 27.5623 14.4251 27.5623 13.7376 27.3248L9.75015 25.9998C8.25015 25.4998 7.02515 23.7998 7.02515 22.2123L7.03765 16.0498L12.5626 19.6498C13.9126 20.5373 16.1376 20.5373 17.4876 19.6498L22.9751 16.0498Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.975 8.07507L17.4875 3.16257C16.1375 2.27507 13.9125 2.27507 12.5625 3.16257L5.03752 8.07507C2.62502 9.63757 2.62502 13.1751 5.03752 14.7501L7.03752 16.0501L12.5625 19.6501C13.9125 20.5376 16.1375 20.5376 17.4875 19.6501L22.975 16.0501L24.6875 14.9251V18.7501C24.6875 19.2626 25.1125 19.6876 25.625 19.6876C26.1375 19.6876 26.5625 19.2626 26.5625 18.7501V12.6001C27.0625 10.9876 26.55 9.11257 24.975 8.07507Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeacher);
export default __webpack_public_path__ + "static/media/icon-teacher.cefc0c64927cc0beeec54c17f6046a38.svg";
export { ForwardRef as ReactComponent };